import React from 'react';

interface Props {
  /** Auswählbare Rollen */
  rollen: string[];
  /** Aktuell gewählte Rollen */
  value: string[];
  onChange: (rollen: string[]) => void;
}

/** Mehrfachauswahl von Rollen als Checkbox-Liste (ein Benutzer kann mehrere Rollen haben). */
const RollenAuswahl: React.FC<Props> = ({ rollen, value, onChange }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 18px' }}>
    {rollen.map(r => (
      <label key={r} style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 400, fontSize: 13 }}>
        <input
          type="checkbox"
          checked={value.includes(r)}
          onChange={() => onChange(value.includes(r) ? value.filter(x => x !== r) : [...value, r])}
        />
        {r}
      </label>
    ))}
  </div>
);

export default RollenAuswahl;
